import _objectWithoutProperties from "/var/lib/jenkins/workspace/common/deploy-external-portal-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/common/deploy-external-portal-frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/var/lib/jenkins/workspace/common/deploy-external-portal-frontend/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/var/lib/jenkins/workspace/common/deploy-external-portal-frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/lib/jenkins/workspace/common/deploy-external-portal-frontend/node_modules/@babel/runtime/helpers/esm/createClass.js";
var _excluded = ["attribution"],
    _excluded2 = ["attribution"],
    _excluded3 = ["attribution"],
    _excluded4 = ["attribution"],
    _excluded5 = ["attribution"],
    _excluded6 = ["attribution"];
import _regeneratorRuntime from "/var/lib/jenkins/workspace/common/deploy-external-portal-frontend/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var pe = Object.defineProperty;

var ve = function ve(n, e, t) {
  return e in n ? pe(n, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : n[e] = t;
};

var u = function u(n, e, t) {
  return ve(n, typeof e != "symbol" ? e + "" : e, t), t;
};

var k;
var ye = new Uint8Array(16);

function Te() {
  if (!k && (k = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !k)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return k(ye);
}

var d = [];

for (var n = 0; n < 256; ++n) {
  d.push((n + 256).toString(16).slice(1));
}

function be(n) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return (d[n[e + 0]] + d[n[e + 1]] + d[n[e + 2]] + d[n[e + 3]] + "-" + d[n[e + 4]] + d[n[e + 5]] + "-" + d[n[e + 6]] + d[n[e + 7]] + "-" + d[n[e + 8]] + d[n[e + 9]] + "-" + d[n[e + 10]] + d[n[e + 11]] + d[n[e + 12]] + d[n[e + 13]] + d[n[e + 14]] + d[n[e + 15]]).toLowerCase();
}

var Pe = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto),
    $ = {
  randomUUID: Pe
};

function Se(n, e, t) {
  if ($.randomUUID && !e && !n) return $.randomUUID();
  n = n || {};
  var i = n.random || (n.rng || Te)();

  if (i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, e) {
    t = t || 0;

    for (var r = 0; r < 16; ++r) {
      e[t + r] = i[r];
    }

    return e;
  }

  return be(i);
}

var R = {
  UNIQUE_ID_KEY: "percept_unique_id",
  USER_ID_KEY: "percept_user_id"
};

var Ee = /*#__PURE__*/function () {
  function Ee() {
    _classCallCheck(this, Ee);
  }

  _createClass(Ee, [{
    key: "clear",
    value: function clear() {
      window == null || window.localStorage.clear();
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return _objectSpread({}, localStorage);
    }
  }, {
    key: "getItem",
    value: function getItem(e) {
      return window == null ? void 0 : window.localStorage.getItem(e);
    }
  }, {
    key: "setItem",
    value: function setItem(e, t) {
      window == null || window.localStorage.setItem(e, t);
    }
  }, {
    key: "multiGet",
    value: function multiGet(e) {
      var _this = this;

      return e.map(function (r) {
        return _this.getItem(r);
      }).map(function (r, a) {
        return [e[a], r];
      });
    }
  }, {
    key: "multiSet",
    value: function multiSet(e) {
      var _this2 = this;

      e.map(function (t) {
        return _this2.setItem(t[0], t[1]);
      });
    }
  }, {
    key: "removeItem",
    value: function removeItem(e) {
      return window == null ? void 0 : window.localStorage.removeItem(e);
    }
  }, {
    key: "multiRemove",
    value: function multiRemove(e) {
      var _this3 = this;

      e.map(function (t) {
        return _this3.removeItem(t);
      });
    }
  }]);

  return Ee;
}();

var v = new Ee(),
    ae = "https://app.perceptinsight.com/track/v1/event",
    I = "PERCEPT_GLOBAL_",
    we = function we() {
  if (navigator) return {
    user_agent: navigator.userAgent
  };
},
    Ie = function Ie() {
  return typeof window < "u" && typeof window.document < "u";
},
    j = function j() {
  return Ie() ? window.location.origin + window.location.pathname : "";
},
    Le = function Le(n) {
  var e;
  (e = window == null ? void 0 : window.sessionStorage) == null || e.setItem("LAST_URL", n);
},
    Ce = function Ce() {
  var n;
  return (n = window == null ? void 0 : window.sessionStorage) == null ? void 0 : n.getItem("LAST_URL");
},
    _e = function _e() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var e = {},
      t = {};
  return Object.keys(n).forEach(function (i) {
    var r = n[i];
    Array.isArray(r) ? t[i] = r : e[i] = r;
  }), {
    data: e,
    multidata: t
  };
},
    Ue = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(n, e) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(ae, {
              keepalive: !0,
              method: "POST",
              headers: {
                "Content-Type": "application/json; charset=UTF-8",
                Authorization: "Bearer ".concat(e)
              },
              body: JSON.stringify({
                events: n
              })
            });

          case 3:
            _context.next = 8;
            break;

          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
            console.log("[PI] beacon failed");

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 5]]);
  }));

  return function Ue(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}(),
    ke = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(n, e) {
    var t,
        i,
        r,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            t = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 1;
            i = 0, r = !1;

          case 2:
            if (!(i < t && !r)) {
              _context2.next = 14;
              break;
            }

            _context2.prev = 3;
            _context2.next = 6;
            return fetch(ae, {
              method: "POST",
              headers: {
                "Content-Type": "application/json; charset=UTF-8",
                Authorization: "Bearer ".concat(e)
              },
              body: JSON.stringify({
                events: n
              })
            });

          case 6:
            r = !0;
            _context2.next = 12;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](3);
            console.log("[PI] api call failed. retry"), i++;

          case 12:
            _context2.next = 2;
            break;

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 9]]);
  }));

  return function ke(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var y,
    C,
    oe,
    q,
    V,
    S = function S() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
},
    _ = function _(n) {
  if (document.readyState === "loading") return "loading";
  var e = S();

  if (e) {
    if (n < e.domInteractive) return "loading";
    if (e.domContentLoadedEventStart === 0 || n < e.domContentLoadedEventStart) return "dom-interactive";
    if (e.domComplete === 0 || n < e.domComplete) return "dom-content-loaded";
  }

  return "complete";
},
    Re = function Re(n) {
  var e = n.nodeName;
  return n.nodeType === 1 ? e.toLowerCase() : e.toUpperCase().replace(/^#/, "");
},
    O = function O(n, e) {
  var t = "";

  try {
    for (; n && n.nodeType !== 9;) {
      var i = n,
          r = i.id ? "#" + i.id : Re(i) + (i.classList && i.classList.value && i.classList.value.trim() && i.classList.value.trim().length ? "." + i.classList.value.trim().replace(/\s+/g, ".") : "");
      if (t.length + r.length > (e || 100) - 1) return t || r;
      if (t = t ? r + ">" + t : r, i.id) break;
      n = i.parentNode;
    }
  } catch (_unused3) {}

  return t;
},
    se = -1,
    ce = function ce() {
  return se;
},
    T = function T(n) {
  addEventListener("pageshow", function (e) {
    e.persisted && (se = e.timeStamp, n(e));
  }, !0);
},
    F = function F() {
  var n = S();
  return n && n.activationStart || 0;
},
    f = function f(n, e) {
  var t = S(),
      i = "navigate";
  return ce() >= 0 ? i = "back-forward-cache" : t && (document.prerendering || F() > 0 ? i = "prerender" : document.wasDiscarded ? i = "restore" : t.type && (i = t.type.replace(/_/g, "-"))), {
    name: n,
    value: e === void 0 ? -1 : e,
    rating: "good",
    delta: 0,
    entries: [],
    id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
    navigationType: i
  };
},
    E = function E(n, e, t) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(n)) {
      var i = new PerformanceObserver(function (r) {
        Promise.resolve().then(function () {
          e(r.getEntries());
        });
      });
      return i.observe(Object.assign({
        type: n,
        buffered: !0
      }, t || {})), i;
    }
  } catch (_unused4) {}
},
    g = function g(n, e, t, i) {
  var r, a;
  return function (o) {
    e.value >= 0 && (o || i) && ((a = e.value - (r || 0)) || r === void 0) && (r = e.value, e.delta = a, e.rating = function (s, c) {
      return s > c[1] ? "poor" : s > c[0] ? "needs-improvement" : "good";
    }(e.value, t), n(e));
  };
},
    z = function z(n) {
  requestAnimationFrame(function () {
    return requestAnimationFrame(function () {
      return n();
    });
  });
},
    x = function x(n) {
  var e = function e(t) {
    t.type !== "pagehide" && document.visibilityState !== "hidden" || n(t);
  };

  addEventListener("visibilitychange", e, !0), addEventListener("pagehide", e, !0);
},
    N = function N(n) {
  var e = !1;
  return function (t) {
    e || (n(t), e = !0);
  };
},
    P = -1,
    H = function H() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
},
    A = function A(n) {
  document.visibilityState === "hidden" && P > -1 && (P = n.type === "visibilitychange" ? n.timeStamp : 0, De());
},
    Y = function Y() {
  addEventListener("visibilitychange", A, !0), addEventListener("prerenderingchange", A, !0);
},
    De = function De() {
  removeEventListener("visibilitychange", A, !0), removeEventListener("prerenderingchange", A, !0);
},
    W = function W() {
  return P < 0 && (P = H(), Y(), T(function () {
    setTimeout(function () {
      P = H(), Y();
    }, 0);
  })), {
    get firstHiddenTime() {
      return P;
    }

  };
},
    U = function U(n) {
  document.prerendering ? addEventListener("prerenderingchange", function () {
    return n();
  }, !0) : n();
},
    Q = [1800, 3e3],
    ue = function ue(n, e) {
  e = e || {}, U(function () {
    var t,
        i = W(),
        r = f("FCP"),
        a = E("paint", function (o) {
      o.forEach(function (s) {
        s.name === "first-contentful-paint" && (a.disconnect(), s.startTime < i.firstHiddenTime && (r.value = Math.max(s.startTime - F(), 0), r.entries.push(s), t(!0)));
      });
    });
    a && (t = g(n, r, Q, e.reportAllChanges), T(function (o) {
      r = f("FCP"), t = g(n, r, Q, e.reportAllChanges), z(function () {
        r.value = performance.now() - o.timeStamp, t(!0);
      });
    }));
  });
},
    J = [0.1, 0.25],
    qe = function qe(n, e) {
  (function (t, i) {
    i = i || {}, ue(N(function () {
      var r,
          a = f("CLS", 0),
          o = 0,
          s = [],
          c = function c(m) {
        m.forEach(function (l) {
          if (!l.hadRecentInput) {
            var w = s[0],
                M = s[s.length - 1];
            o && l.startTime - M.startTime < 1e3 && l.startTime - w.startTime < 5e3 ? (o += l.value, s.push(l)) : (o = l.value, s = [l]);
          }
        }), o > a.value && (a.value = o, a.entries = s, r());
      },
          h = E("layout-shift", c);

      h && (r = g(t, a, J, i.reportAllChanges), x(function () {
        c(h.takeRecords()), r(!0);
      }), T(function () {
        o = 0, a = f("CLS", 0), r = g(t, a, J, i.reportAllChanges), z(function () {
          return r();
        });
      }), setTimeout(r, 0));
    }));
  })(function (t) {
    (function (i) {
      if (i.entries.length) {
        var r = i.entries.reduce(function (s, c) {
          return s && s.value > c.value ? s : c;
        });

        if (r && r.sources && r.sources.length) {
          var a = (o = r.sources).find(function (s) {
            return s.node && s.node.nodeType === 1;
          }) || o[0];
          if (a) return void (i.attribution = {
            largestShiftTarget: O(a.node),
            largestShiftTime: r.startTime,
            largestShiftValue: r.value,
            largestShiftSource: a,
            largestShiftEntry: r,
            loadState: _(r.startTime)
          });
        }
      }

      var o;
      i.attribution = {};
    })(t), n(t);
  }, e);
},
    Ae = function Ae(n, e) {
  ue(function (t) {
    (function (i) {
      if (i.entries.length) {
        var r = S(),
            a = i.entries[i.entries.length - 1];

        if (r) {
          var o = r.activationStart || 0,
              s = Math.max(0, r.responseStart - o);
          return void (i.attribution = {
            timeToFirstByte: s,
            firstByteToFCP: i.value - s,
            loadState: _(i.entries[0].startTime),
            navigationEntry: r,
            fcpEntry: a
          });
        }
      }

      i.attribution = {
        timeToFirstByte: 0,
        firstByteToFCP: i.value,
        loadState: _(ce())
      };
    })(t), n(t);
  }, e);
},
    L = {
  passive: !0,
  capture: !0
},
    Oe = /* @__PURE__ */new Date(),
    X = function X(n, e) {
  y || (y = e, C = n, oe = /* @__PURE__ */new Date(), de(removeEventListener), le());
},
    le = function le() {
  if (C >= 0 && C < oe - Oe) {
    var n = {
      entryType: "first-input",
      name: y.type,
      target: y.target,
      cancelable: y.cancelable,
      startTime: y.timeStamp,
      processingStart: y.timeStamp + C
    };
    q.forEach(function (e) {
      e(n);
    }), q = [];
  }
},
    Fe = function Fe(n) {
  if (n.cancelable) {
    var e = (n.timeStamp > 1e12 ? /* @__PURE__ */new Date() : performance.now()) - n.timeStamp;
    n.type == "pointerdown" ? function (t, i) {
      var r = function r() {
        X(t, i), o();
      },
          a = function a() {
        o();
      },
          o = function o() {
        removeEventListener("pointerup", r, L), removeEventListener("pointercancel", a, L);
      };

      addEventListener("pointerup", r, L), addEventListener("pointercancel", a, L);
    }(e, n) : X(e, n);
  }
},
    de = function de(n) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function (e) {
    return n(e, Fe, L);
  });
},
    Z = [100, 300],
    xe = function xe(n, e) {
  e = e || {}, U(function () {
    var t,
        i = W(),
        r = f("FID"),
        a = function a(c) {
      c.startTime < i.firstHiddenTime && (r.value = c.processingStart - c.startTime, r.entries.push(c), t(!0));
    },
        o = function o(c) {
      c.forEach(a);
    },
        s = E("first-input", o);

    t = g(n, r, Z, e.reportAllChanges), s && x(N(function () {
      o(s.takeRecords()), s.disconnect();
    })), s && T(function () {
      var c;
      r = f("FID"), t = g(n, r, Z, e.reportAllChanges), q = [], C = -1, y = null, de(addEventListener), c = a, q.push(c), le();
    });
  });
},
    Me = function Me(n, e) {
  xe(function (t) {
    (function (i) {
      var r = i.entries[0];
      i.attribution = {
        eventTarget: O(r.target),
        eventType: r.name,
        eventTime: r.startTime,
        eventEntry: r,
        loadState: _(r.startTime)
      };
    })(t), n(t);
  }, e);
},
    he = 0,
    B = 1 / 0,
    D = 0,
    Be = function Be(n) {
  n.forEach(function (e) {
    e.interactionId && (B = Math.min(B, e.interactionId), D = Math.max(D, e.interactionId), he = D ? (D - B) / 7 + 1 : 0);
  });
},
    me = function me() {
  return V ? he : performance.interactionCount || 0;
},
    Ke = function Ke() {
  "interactionCount" in performance || V || (V = E("event", Be, {
    type: "event",
    buffered: !0,
    durationThreshold: 0
  }));
},
    ee = [200, 500],
    fe = 0,
    te = function te() {
  return me() - fe;
},
    p = [],
    K = {},
    ne = function ne(n) {
  var e = p[p.length - 1],
      t = K[n.interactionId];

  if (t || p.length < 10 || n.duration > e.latency) {
    if (t) t.entries.push(n), t.latency = Math.max(t.latency, n.duration);else {
      var i = {
        id: n.interactionId,
        latency: n.duration,
        entries: [n]
      };
      K[i.id] = i, p.push(i);
    }
    p.sort(function (r, a) {
      return a.latency - r.latency;
    }), p.splice(10).forEach(function (r) {
      delete K[r.id];
    });
  }
},
    Ge = function Ge(n, e) {
  e = e || {}, U(function () {
    Ke();

    var t,
        i = f("INP"),
        r = function r(o) {
      o.forEach(function (h) {
        h.interactionId && ne(h), h.entryType === "first-input" && !p.some(function (m) {
          return m.entries.some(function (l) {
            return h.duration === l.duration && h.startTime === l.startTime;
          });
        }) && ne(h);
      });
      var s,
          c = (s = Math.min(p.length - 1, Math.floor(te() / 50)), p[s]);
      c && c.latency !== i.value && (i.value = c.latency, i.entries = c.entries, t());
    },
        a = E("event", r, {
      durationThreshold: e.durationThreshold || 40
    });

    t = g(n, i, ee, e.reportAllChanges), a && (a.observe({
      type: "first-input",
      buffered: !0
    }), x(function () {
      r(a.takeRecords()), i.value < 0 && te() > 0 && (i.value = 0, i.entries = []), t(!0);
    }), T(function () {
      p = [], fe = me(), i = f("INP"), t = g(n, i, ee, e.reportAllChanges);
    }));
  });
},
    Ve = function Ve(n, e) {
  Ge(function (t) {
    (function (i) {
      if (i.entries.length) {
        var r = i.entries.sort(function (a, o) {
          return o.duration - a.duration || o.processingEnd - o.processingStart - (a.processingEnd - a.processingStart);
        })[0];
        i.attribution = {
          eventTarget: O(r.target),
          eventType: r.name,
          eventTime: r.startTime,
          eventEntry: r,
          loadState: _(r.startTime)
        };
      } else i.attribution = {};
    })(t), n(t);
  }, e);
},
    re = [2500, 4e3],
    G = {},
    ze = function ze(n, e) {
  (function (t, i) {
    i = i || {}, U(function () {
      var r,
          a = W(),
          o = f("LCP"),
          s = function s(m) {
        var l = m[m.length - 1];
        l && l.startTime < a.firstHiddenTime && (o.value = Math.max(l.startTime - F(), 0), o.entries = [l], r());
      },
          c = E("largest-contentful-paint", s);

      if (c) {
        r = g(t, o, re, i.reportAllChanges);
        var h = N(function () {
          G[o.id] || (s(c.takeRecords()), c.disconnect(), G[o.id] = !0, r(!0));
        });
        ["keydown", "click"].forEach(function (m) {
          addEventListener(m, h, !0);
        }), x(h), T(function (m) {
          o = f("LCP"), r = g(t, o, re, i.reportAllChanges), z(function () {
            o.value = performance.now() - m.timeStamp, G[o.id] = !0, r(!0);
          });
        });
      }
    });
  })(function (t) {
    (function (i) {
      if (i.entries.length) {
        var r = S();

        if (r) {
          var a = r.activationStart || 0,
              o = i.entries[i.entries.length - 1],
              s = o.url && performance.getEntriesByType("resource").filter(function (M) {
            return M.name === o.url;
          })[0],
              c = Math.max(0, r.responseStart - a),
              h = Math.max(c, s ? (s.requestStart || s.startTime) - a : 0),
              m = Math.max(h, s ? s.responseEnd - a : 0),
              l = Math.max(m, o ? o.startTime - a : 0),
              w = {
            element: O(o.element),
            timeToFirstByte: c,
            resourceLoadDelay: h - c,
            resourceLoadTime: m - h,
            elementRenderDelay: l - m,
            navigationEntry: r,
            lcpEntry: o
          };
          return o.url && (w.url = o.url), s && (w.lcpResourceEntry = s), void (i.attribution = w);
        }
      }

      i.attribution = {
        timeToFirstByte: 0,
        resourceLoadDelay: 0,
        resourceLoadTime: 0,
        elementRenderDelay: i.value
      };
    })(t), n(t);
  }, e);
},
    ie = [800, 1800],
    Ne = function n(e) {
  document.prerendering ? U(function () {
    return n(e);
  }) : document.readyState !== "complete" ? addEventListener("load", function () {
    return n(e);
  }, !0) : setTimeout(e, 0);
},
    We = function We(n, e) {
  e = e || {};
  var t = f("TTFB"),
      i = g(n, t, ie, e.reportAllChanges);
  Ne(function () {
    var r = S();

    if (r) {
      var a = r.responseStart;
      if (a <= 0 || a > performance.now()) return;
      t.value = Math.max(a - F(), 0), t.entries = [r], i(!0), T(function () {
        t = f("TTFB", 0), (i = g(n, t, ie, e.reportAllChanges))(!0);
      });
    }
  });
},
    $e = function $e(n, e) {
  We(function (t) {
    (function (i) {
      if (i.entries.length) {
        var r = i.entries[0],
            a = r.activationStart || 0,
            o = Math.max(r.domainLookupStart - a, 0),
            s = Math.max(r.connectStart - a, 0),
            c = Math.max(r.requestStart - a, 0);
        i.attribution = {
          waitingTime: o,
          dnsTime: s - o,
          connectionTime: c - s,
          requestTime: i.value - c,
          navigationEntry: r
        };
      } else i.attribution = {
        waitingTime: 0,
        dnsTime: 0,
        connectionTime: 0,
        requestTime: 0
      };
    })(t), n(t);
  }, e);
};

var b = "$webVitals";

var je = /*#__PURE__*/_createClass(function je() {
  var _this4 = this;

  _classCallCheck(this, je);

  u(this, "tracker");
  u(this, "init", function (e) {
    console.log("init web vitals"), _this4.tracker = e, qe(_this4.trackCLS), Me(_this4.trackFID), ze(_this4.trackLCP), $e(_this4.trackTTFB), Ae(_this4.trackFCP), Ve(_this4.trackINP);
  });
  u(this, "trackCLS", function (e) {
    var a;

    var t = e.attribution,
        i = _objectWithoutProperties(e, _excluded),
        r = _this4.getGenericEventProps(i);

    r.pi_metric_debug_target = (a = t == null ? void 0 : t.largestShiftTarget) == null ? void 0 : a.toString(), _this4.tracker(b, r);
  });
  u(this, "trackFID", function (e) {
    var a;

    var t = e.attribution,
        i = _objectWithoutProperties(e, _excluded2),
        r = _this4.getGenericEventProps(i);

    r.pi_metric_debug_target = (a = t == null ? void 0 : t.eventTarget) == null ? void 0 : a.toString(), _this4.tracker(b, r);
  });
  u(this, "trackLCP", function (e) {
    var a;

    var t = e.attribution,
        i = _objectWithoutProperties(e, _excluded3),
        r = _this4.getGenericEventProps(i);

    r.pi_metric_debug_target = (a = t == null ? void 0 : t.element) == null ? void 0 : a.toString(), _this4.tracker(b, r);
  });
  u(this, "trackTTFB", function (e) {
    var t = e.attribution,
        i = _objectWithoutProperties(e, _excluded4),
        r = _this4.getGenericEventProps(i);

    _this4.tracker(b, r);
  });
  u(this, "trackFCP", function (e) {
    var t = e.attribution,
        i = _objectWithoutProperties(e, _excluded5),
        r = _this4.getGenericEventProps(i);

    _this4.tracker(b, r);
  });
  u(this, "trackINP", function (e) {
    var a;

    var t = e.attribution,
        i = _objectWithoutProperties(e, _excluded6),
        r = _this4.getGenericEventProps(i);

    r.pi_metric_debug_target = (a = t == null ? void 0 : t.eventTarget) == null ? void 0 : a.toString(), _this4.tracker(b, r);
  });
  u(this, "getGenericEventProps", function (e) {
    return {
      pi_metric_id: e.id,
      pi_metric_name: e.name,
      pi_metric_value: e.value.toString(),
      pi_metric_rating: e.rating,
      pi_metric_navigation_type: e.navigationType
    };
  });
});

var He = new je();

var Ye = /*#__PURE__*/function () {
  // private sessionStartTimestamp: number | undefined;
  function Ye() {
    _classCallCheck(this, Ye);

    u(this, "isSDKInitialized", !1);
    u(this, "timeThresholdMilliseconds");
    u(this, "batchSize");
    u(this, "batchCheckTimer");
    u(this, "token");
    u(this, "userId");
    u(this, "batchedEventRequests");
    u(this, "deviceProperties");
    u(this, "uniqueId");
    u(this, "globalProerties", {});
    u(this, "utmParams", {});
    u(this, "domObserver");
    this.timeThresholdMilliseconds = 3e3, this.batchSize = 30, this.batchCheckTimer = null, this.batchedEventRequests = [];
  }

  _createClass(Ye, [{
    key: "init",
    value: function init(e) {
      if (this.isSDKInitialized) {
        console.log("Percept SDK has already been initialized. This call will be ignored");
        return;
      }

      if (!e) throw new Error("Percept token is mandatory for initializing the SDK");
      this.token = e;

      try {
        this.deviceProperties = we();
      } catch (i) {
        console.error("[PI]: error fetching device properties"), console.error(i);
      }

      this.setUtmParams(), this.addListeners(), this.isSDKInitialized = !0, this.setUpAutoPageViewTracking();
      var t = this.capture.bind(this);
      He.init(t);
    }
  }, {
    key: "clear",
    value: function clear() {
      try {
        v.clear();
      } catch (e) {
        console.error("[PI]: error clearing device properties"), console.error(e);
      }
    }
  }, {
    key: "setUserId",
    value: function setUserId(e) {
      if (this.canProcessRequests()) {
        this.userId = e;

        try {
          v.setItem(R.USER_ID_KEY, e);
        } catch (t) {
          console.error("[PI]: error setting user id"), console.error(t);
        }
      }
    }
  }, {
    key: "capture",
    value: function () {
      var _capture = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
        var t,
            i,
            r,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                t = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};

                if (!this.canProcessRequests()) {
                  _context3.next = 19;
                  break;
                }

                _context3.prev = 2;
                t.user_id = this.getUserId(), t.unique_id = this.getUniqueId(), t.client_ts = Date.now();
                i = this.getAllGlobalProperties();
                t = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, t), i), this.deviceProperties), this.utmParams), Object.keys(t).forEach(function (a) {
                  return t[a] === void 0 && delete t[a];
                });
                r = _e(t);
                this.batchedEventRequests.push(_objectSpread({
                  name: e
                }, r));

                if (!(this.batchedEventRequests.length >= this.batchSize)) {
                  _context3.next = 13;
                  break;
                }

                _context3.next = 11;
                return this.sendBatchedApiCallsWithRetry();

              case 11:
                _context3.next = 14;
                break;

              case 13:
                this.startTimer();

              case 14:
                _context3.next = 19;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](2);
                console.error("[PI]: error capturing event"), console.error(_context3.t0);

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 16]]);
      }));

      function capture(_x5) {
        return _capture.apply(this, arguments);
      }

      return capture;
    }()
  }, {
    key: "setGlobalProperty",
    value: function setGlobalProperty(e, t) {
      if (!this.canProcessRequests()) return;
      var i = "".concat(I).concat(e);

      try {
        v.setItem(i, t);
      } catch (r) {
        console.error("[PI]: error setting global property: ".concat(e)), console.error(r);
      }
    }
  }, {
    key: "removeGlobalProperty",
    value: function removeGlobalProperty(e) {
      if (this.canProcessRequests()) try {
        v.removeItem("".concat(I).concat(e));
      } catch (t) {
        console.error("[PI]: error removing global property: ".concat(e)), console.error(t);
      }
    }
  }, {
    key: "getAllGlobalProperties",
    value: function getAllGlobalProperties() {
      if (this.canProcessRequests()) try {
        var e = v.getAll(),
            t = Object.keys(e).filter(function (a) {
          return a.startsWith(I);
        });
        if (Object.keys(this.globalProerties).length === t.length) return this.globalProerties;
        var i = {},
            r = I.length;
        return t.forEach(function (a) {
          var o = a.slice(r);
          a.indexOf(I) === 0 && (i[o] = e[a]);
        }), this.globalProerties = _objectSpread({}, i), this.globalProerties;
      } catch (e) {
        console.error("[PI]: error fetching global properties"), console.error(e);
      }
    }
  }, {
    key: "getUserId",
    value: function getUserId() {
      if (this.userId) return this.userId;

      try {
        var e = v.getItem(R.USER_ID_KEY);
        e != null && (this.userId = e);
      } catch (_unused5) {} finally {
        return this.userId;
      }
    }
  }, {
    key: "createAndSetUniqueid",
    value: function createAndSetUniqueid() {
      this.uniqueId = Se();

      try {
        v.setItem(R.UNIQUE_ID_KEY, this.uniqueId);
      } catch (e) {
        console.error("[PI]: error setting unique id"), console.error(e);
      }
    }
  }, {
    key: "getUniqueId",
    value: function getUniqueId() {
      if (this.uniqueId) return this.uniqueId;

      try {
        var e = v.getItem(R.UNIQUE_ID_KEY);
        if (e != null) return this.uniqueId = e, this.uniqueId;
        this.createAndSetUniqueid();
      } catch (_unused6) {
        this.createAndSetUniqueid();
      } finally {
        return this.uniqueId;
      }
    }
  }, {
    key: "isInitializedWithToken",
    value: function isInitializedWithToken() {
      return !!(this.isSDKInitialized && this.token);
    }
  }, {
    key: "canProcessRequests",
    value: function canProcessRequests() {
      if (!this.isInitializedWithToken()) throw new Error("Percept token is missing. You might have missed initializing the SDK");
      return !0;
    }
  }, {
    key: "setUtmParams",
    value: function setUtmParams() {
      var e = new URL(window.location.href),
          t = e.searchParams.get("utm_source"),
          i = e.searchParams.get("utm_medium"),
          r = e.searchParams.get("utm_campaign");
      !t && !r && !r || (this.utmParams = {
        utm_source: t,
        utm_medium: i,
        utm_campaign: r
      });
    }
  }, {
    key: "isSameUrl",
    value: function isSameUrl() {
      var e = j();
      return Ce() === e;
    }
  }, {
    key: "capturePageView",
    value: function capturePageView() {
      var e = j();
      this.capture("$pageView", {
        url: e
      }), Le(e);
    } // private captureSessionEnd() {
    //   let currentTimestamp = Date.now();
    //   if(!this.sessionStartTimestamp) return;
    //   let timeSpent = currentTimestamp - this.sessionStartTimestamp;
    //   this.capture('$sessionEnd', {time_spent_ms: timeSpent})
    // }

  }, {
    key: "setUpAutoPageViewTracking",
    value: function setUpAutoPageViewTracking() {
      var _this5 = this;

      this.capturePageView(), this.domObserver = new MutationObserver(function () {
        _this5.isSameUrl() || _this5.capturePageView();
      });
      var e = {
        subtree: !0,
        childList: !0
      };
      this.domObserver.observe(document, e);
    }
  }, {
    key: "addListeners",
    value: function addListeners() {
      var _this6 = this;

      var e = function e() {
        _this6.flushOnUnload();
      },
          t = function t() {
        document.visibilityState === "hidden" && _this6.flushOnUnload();
      },
          i = function i() {
        var r;
        (r = _this6.domObserver) == null || r.disconnect(), window.removeEventListener("pagehide", e), window.removeEventListener("visibilitychange", t), _this6.flushOnUnload();
      };

      window.addEventListener("pagehide", e), window.addEventListener("visibilitychange", t), window.addEventListener("beforeunload", i);
    }
  }, {
    key: "flushOnUnload",
    value: function flushOnUnload() {
      this.batchCheckTimer && clearTimeout(this.batchCheckTimer), !(this.batchedEventRequests.length < 1) && (Ue(this.batchedEventRequests, this.token), this.batchedEventRequests = []);
    }
  }, {
    key: "startTimer",
    value: function startTimer() {
      var _this7 = this;

      this.batchCheckTimer && clearTimeout(this.batchCheckTimer), this.batchCheckTimer = setTimeout(function () {
        _this7.sendBatchedApiCallsWithRetry();
      }, this.timeThresholdMilliseconds);
    }
  }, {
    key: "sendBatchedApiCallsWithRetry",
    value: function () {
      var _sendBatchedApiCallsWithRetry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this8 = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.token) {
                  _context5.next = 2;
                  break;
                }

                throw new Error("Percept token is missing. You might have missed initializing the SDK");

              case 2:
                return _context5.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e) {
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.prev = 0;
                            _this8.batchCheckTimer && clearTimeout(_this8.batchCheckTimer);
                            _context4.next = 4;
                            return ke(_this8.batchedEventRequests, _this8.token);

                          case 4:
                            _context4.next = 9;
                            break;

                          case 6:
                            _context4.prev = 6;
                            _context4.t0 = _context4["catch"](0);
                            console.error("[PI]: final api failure"), console.error(_context4.t0);

                          case 9:
                            _context4.prev = 9;
                            _this8.batchedEventRequests = [], e(null);
                            return _context4.finish(9);

                          case 12:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, null, [[0, 6, 9, 12]]);
                  }));

                  return function (_x6) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function sendBatchedApiCallsWithRetry() {
        return _sendBatchedApiCallsWithRetry.apply(this, arguments);
      }

      return sendBatchedApiCallsWithRetry;
    }()
  }]);

  return Ye;
}();

var ge = new Ye();
Object.seal(ge);
typeof window < "u" && (window.percept = ge);
export { ge as default };